const mutations = {
  INITIALIZE(state, { uriAuths }) {
    state.uriAuths = uriAuths
  },
  RESET(state) {
    state.uriAuths = []
  },
}

export default mutations
